/* import __COLOCATED_TEMPLATE__ from './settling-tab-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';
import PrettyNum from '../utils/pretty-num-wrapper';
import { htmlSafe } from '@ember/template';

export default class SettlingTabPanel extends Component {
    tagName = '';

    @service intl;
    @service('data') model;
    @service toolData;
    @service plotData;
    @service errorHandling;
    @service componentManager;
    @service hashDataService;
    @service sigmaDeltaData;
    @service tabService;

    panelId = null;

    gridType = '';
    modalBodyArgs = {};
    errorArgs = {};

    error = null;
    errorTranslation = '';

    @computed('model.isSequencerEnabled') get showLegend() {
        return this.model.isSequencerEnabled;
    }

    @computed(
        'lsbError',
        'cycleLsbLine',
        'vcap',
        'cycleLine',
        'ppmError',
        'cyclePpmLine',
        'model.{inputSettlingChart,isSequencerEnabled}',
    )
    get inputSettlingChartPlotLines() {
        let result = [
            {
                array: this.lsbError,
                name: this.model.isSequencerEnabled
                    ? this.intl.t('legend_labels.inx')
                    : this.intl.t('legend_labels.actual_adc_input'),
                color: this.toolData.data.colors.noiseDriver,
                hidden: this.model.inputSettlingChart != 1,
            },
            {
                arrayWithX: this.cycleLsbLine,
                name: 'cycle2Lsb',
                color: '#333',
                markers: true,
                hideLegend: true,
                hidden: this.model.inputSettlingChart != 1,
            },
            {
                array: this.vcap,
                name: this.model.isSequencerEnabled
                    ? this.intl.t('legend_labels.inx')
                    : this.intl.t('legend_labels.actual_adc_input'),
                color: this.toolData.data.colors.noiseDriver,
                hidden: this.model.inputSettlingChart != 2,
            },
            {
                arrayWithX: this.cycleLine,
                name: 'cycle2',
                color: '#333',
                markers: true,
                hideLegend: true,
                hidden: this.model.inputSettlingChart != 2,
            },
            {
                array: this.ppmError,
                name: this.model.isSequencerEnabled ? this.intl.t('legend_labels.inx') : this.intl.t('chart_tabs.ppm'),
                color: this.toolData.data.colors.noiseDriver,
                hidden: this.model.inputSettlingChart != 3,
            },
            {
                arrayWithX: this.cyclePpmLine,
                name: 'cycle2Ppm',
                color: '#333',
                markers: true,
                hideLegend: true,
                hidden: this.model.inputSettlingChart != 3,
            },
        ];

        let foundPlotLine = result.find((item) => !!item.array && !item.hidden);
        if (foundPlotLine && this.model.isSequencerEnabled) {
            let inyData = foundPlotLine.array.map(() => 0);
            result.unshift({
                array: inyData,
                name: this.intl.t('legend_labels.iny'),
                color: 'orange',
            });
        }

        return result;
    }

    @computed('model.inputSettlingChart') get yLabel() {
        let result = null;

        switch (this.model.inputSettlingChart) {
            case 1:
                result = this.intl.t('chart_tabs.lsb'); //'LSB Error';
                break;
            case 2:
                result = this.intl.t('chart_tabs.adc_input'); //'ADC Input (Volts)';
                break;
            case 3:
                result = this.intl.t('chart_tabs.ppm'); //'PPM Error';
                break;
        }

        return result;
    }

    @computed('gridType', 'model.frequency') get gridTitle() {
        return this.intl.t(`tabs.${this.gridType}.title`, { frequency: PrettyNum.eng3(this.model.frequency) });
    }

    @computed('errorTranslation', 'errorArgs') get errorMessage() {
        if (this.errorTranslation) {
            return htmlSafe(this.intl.t(this.errorTranslation, this.errorArgs));
        } else {
            return '';
        }
    }

    @computed('warningTranslation', 'warningArgs') get warningMessage() {
        return this.intl.t(this.warningTranslation, this.warningArgs);
    }

    @computed('gridType') get warningQAAttrText() {
        return `${this.gridType}_in_sig_tab_msg`;
    }

    @computed('gridType') get modalName() {
        return `${this.gridType}_input_signal`;
    }

    @computed('gridType') get chartId() {
        return `${this.gridType}Chart`;
    }

    @computed('gridType', 'model.showLsbChart') get cycleLabelTop() {
        return this.gridType === this.plotData.inputSettlingConfig.ac.name && this.model.showLsbChart;
    }

    @action toggleChart(toggled) {
        this.set('model.inputSettlingChart', toggled);
        this.setInputSettlingChartUrlParameter();

        if (this.updateAppData) this.updateAppData();
    }

    setInputSettlingChartUrlParameter() {
        this.hashDataService.setUrlParameter('model.inputSettlingChart');
    }
}
